import { motion } from "framer-motion";

// Soft hand-drawn wave separator instead of a hard block edge
export const InkDivider = ({ color = "var(--ink)", className = "" }) => {
  return (
    <div className={`w-full overflow-hidden ${className}`} aria-hidden="true">
      <svg
        viewBox="0 0 1440 120"
        className="w-full h-[60px] sm:h-[90px]"
        preserveAspectRatio="none"
        fill="none"
      >
        <motion.path
          d="M0,70 C180,20 320,110 520,70 C720,30 860,110 1060,72 C1240,40 1360,90 1440,64"
          stroke={color}
          strokeWidth="1.6"
          strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 0.7 }}
          viewport={{ once: true }}
          transition={{ duration: 1.6, ease: "easeInOut" }}
        />
        <motion.path
          d="M0,84 C200,52 360,118 560,86 C760,54 900,116 1100,88 C1280,64 1380,96 1440,82"
          stroke={color}
          strokeWidth="1"
          strokeDasharray="2 9"
          strokeLinecap="round"
          initial={{ pathLength: 0, opacity: 0 }}
          whileInView={{ pathLength: 1, opacity: 0.4 }}
          viewport={{ once: true }}
          transition={{ duration: 1.8, delay: 0.2, ease: "easeInOut" }}
        />
      </svg>
    </div>
  );
};

export default InkDivider;
